import { useMutation } from "@tanstack/react-query";
import { eventsApi } from "@/lib/humhub-api/events";

interface UpdateEventEmailParams {
  eventId: number;
  email_subject: string;
  email_body_html: string;
  email_body_text?: string;
  save_for_reminder: boolean;
  save_for_entry?: boolean;
  send_now?: boolean;
  test_mode?: boolean;
  reminderId?: number | null;
  participation_states?: number[];
  include_creator?: boolean;
}

export const useUpdateEventEmail = () => {
  return useMutation({
    mutationFn: async (params: UpdateEventEmailParams) => {
      const {
        eventId,
        email_subject,
        email_body_html,
        email_body_text,
        ...payload
      } = params;

      const shouldSaveEntryTemplate =
        payload.save_for_entry &&
        !payload.save_for_reminder &&
        !payload.send_now &&
        !payload.test_mode;

      if (shouldSaveEntryTemplate) {
        return eventsApi.updateEvent(eventId, {
          CalendarEntryForm: {
            email_subject_custom: email_subject,
            email_body_html_custom: email_body_html,
            email_body_text_custom: email_body_text,
            scope: "single",
          },
        });
      }

      return eventsApi.sendReminderEmail(eventId, {
        email_subject,
        email_body_html,
        email_body_text,
        ...payload,
      });
    },
  });
};
